"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var suffixes = ['', 'K', 'M', 'B', 'T'];

function getDisplayNumber(number) {
  if (number < 1000) {
    return Math.floor(number);
  }

  var thousands = Math.pow(1000, Math.floor(Math.log(number) / Math.log(1000)));
  var thousandsNumber = number / thousands;
  var offset = Math.pow(10, 3 - Math.ceil(Math.log(thousandsNumber) / Math.log(10)));
  var roundNumber = Math.floor(thousandsNumber * offset) / offset;
  return roundNumber;
}

function getDisplaySuffix(number) {
  if (number < 1000) {
    return '';
  }

  var thousands = Math.floor(Math.log(number) / Math.log(1000));
  return thousands < 5 ? suffixes[thousands] : '?';
}

var ShortNumber =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ShortNumber, _React$Component);

  function ShortNumber() {
    (0, _classCallCheck2.default)(this, ShortNumber);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShortNumber).apply(this, arguments));
  }

  (0, _createClass2.default)(ShortNumber, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          numberClassName = _this$props.numberClassName,
          suffixClassName = _this$props.suffixClassName,
          value = _this$props.value;

      if (value === null || value === undefined) {
        return null;
      }

      var shortNumber = getDisplayNumber(value);
      var shortSuffix = getDisplaySuffix(value);
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
        className: numberClassName
      }, shortNumber || 0), _react.default.createElement("span", {
        className: suffixClassName
      }, shortSuffix || ''));
    }
  }]);
  return ShortNumber;
}(_react.default.Component);

var _default = ShortNumber;
exports.default = _default;